import {GA_DISABLED} from "./Constants";

function SendGAWConversionEvent () {
    if (GA_DISABLED) {
        return;
    }

    const gtag = window.gtag;
    if (gtag) {
        gtag('event', 'conversion', {'send_to': 'AW-10785371086/VpVZCOfRoYgDEM7n7pYo'});
    }
}

export default SendGAWConversionEvent;


// WEBPACK FOOTER //
// ./src/utils/SendGAWEvent.js